export default {
  evaluation_dashboard: {
    title: "Tableau de bord de l'acheteur",
    unit: 'Entreprises',
    average: 'Score moyen',
    point: 'points',
    answered_label: 'Soumis',
    evaluated_label: 'Évalué',
    // corporate_average: "",
    points_earned_by_companies: 'Répartition des scores de vos fournisseurs',
    year_modal: {
      title: 'Sélectionner une année',
      label: 'Année',
    },
    response_status_title: "Distribution de l'état de réponse",
    response_status_rating_nothing: 'Pas encore de réponses',
    esg_rating_title: 'Distribution des notes ESG',
    esg_score_title: 'Distribution des scores ESG',
    category_scores_title: 'Comparer les scores par catégorie',
    category_scores_distribution_title: 'Distribution des scores par catégorie',
    category_score_data_all_label: 'Toutes les entreprises évaluées par Asene ESG',
    esg_scores_by_industry_title: "Distribution des scores ESG par secteur d'activité",
    environment_score_title: 'Distribution des scores en matière d’environnement',
    social_score_title: 'Distribution des scores en matière sociale',
    governance_score_title: 'Distribution des scores en matière de gouvernance',
    environment_score_subtitle_upper5: "Les 5 meilleurs scores en matière d'environnement",
    environment_score_subtitle_lower5: 'Les 5 pires scores en matière d’environnement',
    social_score_subtitle_upper5: 'Les 5 meilleurs scores en matière sociale',
    social_score_subtitle_lower5: 'Les 5 pires scores en matière sociale',
    governance_score_subtitle_upper5: 'Les 5 meilleurs scores en matière de gouvernance',
    governance_score_subtitle_lower5: 'Les 5 pires scores en matière de gouvernance',
    // empty_error_message: "",
    common: {
      companies: 'Entreprises',
      update_date: 'Date de la dernière mise à jour',
    },
    registration_rate: {
      title: "Taux d'enregistrement",
      tip: "Entreprises enregistrées dans ASUENE ESG sur le nombre total d'entreprises à évaluer",
    },
    answer_rate: {
      title: 'Taux de soumission',
      tip: "Entreprises ayant soumis l'enquête sur le nombre total d'entreprises à évaluer",
    },
    days_remaining: {
      title: "Jours jusqu'à la fin de l'enquête",
      tip: "Jours restants jusqu'à la date limite fixée.\nSi vous souhaitez modifier la date limite, veuillez nous contacter.",
      days_remaining_before: '',
      days_remaining_after: 'jours restants',
      expired: 'Le délai a été dépassé.',
    },
    answer_transition: {
      title: 'Évolution de la soumission',
      companies_submitted: 'Entreprises soumises',
      breakdown: 'Répartition',
      unregistered: 'Non enregistré',
      total: 'Total de',
      number_of_companies: "Nombre d'entreprises",
    },
    answer_list: {
      title: 'Dernière soumission',
      submitted_at: 'Date de la réponse',
    },
  },
}
